import styled from "styled-components"

export const StyledFooterNew = styled.section`
    display: flex;
    flex-direction: column;

    img {
        margin-bottom: 10px;
        width: 32px;
        background-color: #0000007d;
        background-color: #d690a8;
        padding: 4px;
        border-radius: 8px;

        &:hover,
        &:focus {
            background-color: #cb6e8f !important;
        }
    }

    @media screen and (max-width: 472px) {
        img {
            width: 26px;
        }
    }
`